export default "<style>\r\n\r\n</style>\r\n\r\n<external--video data-insight=\"15\" data-max-insight-height=\"10px\">\r\n@{}\r\n</external--video>\r\n\r\n\r\n";